import styled from 'styled-components';

import getColor from 'happytree';

import { Flex } from '../../../Box';

export const ModalFooterActions = styled(Flex)`
  margin-left: auto;
  padding-left: 24px;
  flex-direction: row-reverse;
`;

export const ModalFooterStatus = styled(Flex)`
  margin-right: auto;
  align-items: center;
`;

export const ModalFooter = styled(Flex)`
  border-top: 1px solid ${getColor('neutral', 2)};
  position: relative;
`;
